'use client'

import { RadioSingleSelect } from '@components/primitives/HtmlForm/RadioSingleSelect.client'
import { Text } from '@components/primitives/Text'
import { SubstanceFrequency } from '@modules/patientTrialApplications/createDetailedSubstanceData'
import { STRUCTURED_QUESTION_UNSURE } from './const'
import { debounceTrackQuestionModified } from './trackQuestionModified'
import type { ConditionCollectElementProps } from './types'

const debouncedEventTracking = debounceTrackQuestionModified(
  'currentSubstancesFrequency',
)

export default function CollectCurrentSubstanceFrequency({
  formRef,
  patientProfileData: { currentSubstanceFrequency },
  questionConfig,
}: ConditionCollectElementProps) {
  const handleInputChange = (newInputValue: string) => {
    debouncedEventTracking(newInputValue)
    if (formRef && formRef.current) {
      formRef.current.requestSubmit()
    }
  }

  return (
    <div className='flex w-full flex-col gap-2'>
      <Text
        className='text-neutral900'
        element={'p'}
        styleName='h3'
        value='How often do you use these substances?'
      />
      <Text
        className='leading-snug text-neutral900 md:leading-normal'
        element={'p'}
        styleName='p-small'
        value='Select the option that best fits.'
      />
      <div className='grid grid-cols-1 gap-2'>
        <RadioSingleSelect
          defaultValue={currentSubstanceFrequency[0]}
          name={questionConfig.id}
          onChange={handleInputChange}
          options={SUBSTANCE_FREQUENCY_OPTIONS}
          required={!questionConfig.skippable}
        />
      </div>
    </div>
  )
}

const SUBSTANCE_FREQUENCY_OPTIONS = [
  {
    label: 'Multiple times a day',
    value: SubstanceFrequency.HOURLY,
  },
  {
    label: 'Daily',
    value: SubstanceFrequency.DAILY,
  },
  {
    label: 'Monthly',
    value: SubstanceFrequency.MONTHLY,
  },
  {
    label: 'A few times a year',
    value: SubstanceFrequency.YEARLY,
  },
  {
    label: STRUCTURED_QUESTION_UNSURE,
    value: STRUCTURED_QUESTION_UNSURE,
  },
]
